import L_HTML5 from "../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../assets/img/skills/css3.svg";

import L_BOOTSTRAP from "../../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../../assets/img/skills/react.svg";
import L_REDUX from "../../assets/img/skills/redux.svg";
import L_REACT_ROUTER from "../../assets/img/skills/react-router.svg";

import L_REACT_BOOTSTRAP from "../../assets/img/skills/react-bootstrap.svg";
import L_STYLED_COMPONENTS from "../../assets/img/skills/styled-components.svg";
import L_NODE_JS from "../../assets/img/skills/nodejs.svg";

import L_FLASK from "../../assets/img/skills/flask.svg";
import L_MONGODB from "../../assets/img/skills/mongodb.svg";
import L_MYSQL from "../../assets/img/skills/mysql.svg";

import L_GIT from "../../assets/img/skills/git-icon.svg";
import L_SOLIDWORKS from "../../assets/img/skills/solidworks.svg";

import L_HEROKU from "../../assets/img/skills/heroku.svg";
import L_FIREBASE from "../../assets/img/skills/firebase-1.svg";
import L_GITHUB_PAGES from "../../assets/img/skills/github.svg";
import L_NETLIFY from "../../assets/img/skills/netlify.svg";

import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
import L_PYTHON from "../../assets/img/skills/python.svg";
import L_C_PROG from "../../assets/img/skills/c.svg";
import L_CPP from "../../assets/img/skills/cpp.svg";
import L_R_PROG from "../../assets/img/skills/r-lang.svg";
import L_JAVA from "../../assets/img/skills/java.svg";
import L_ARDUINO from "../../assets/img/skills/arduino.svg";

export const skills = {
  frontend: [
    {
      imgAltText: "HTML 5",
      imgSrc: L_HTML5,
      skillName: "HTML 5",
    },
    {
      imgAltText: "CSS 3",
      imgSrc: L_CSS3,
      skillName: "CSS3",
    },
    {
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },

    {
      imgAltText: "Bootstrap",
      imgSrc: L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
    {
      imgAltText: "React JS",
      imgSrc: L_REACT,
      skillName: "React JS",
    },
    {
      imgAltText: "Redux",
      imgSrc: L_REDUX,
      skillName: "Redux",
    },
    {
      imgAltText: "React Router",
      imgSrc: L_REACT_ROUTER,
      skillName: "React Router",
    },
    {
      imgAltText: "React Bootstrap",
      imgSrc: L_REACT_BOOTSTRAP,
      skillName: "React Bootstrap",
    },
    {
      imgAltText: "styled-components",
      imgSrc: L_STYLED_COMPONENTS,
      skillName: "styled-components",
    },
  ],

  backend: [
    {
      imgAltText: "Node.js",
      imgSrc: L_NODE_JS,
      skillName: "Node.js",
    },

    {
      imgAltText: "Flask",
      imgSrc: L_FLASK,
      skillName: "Flask",
    },
  ],
  hostingPlatforms: [
    {
      imgAltText: "Heroku",
      imgSrc: L_HEROKU,
      skillName: "Heroku",
    },
    {
      imgAltText: "Firebase",
      imgSrc: L_FIREBASE,
      skillName: "Firebase",
    },
    {
      imgAltText: "GitHub Pages",
      imgSrc: L_GITHUB_PAGES,
      skillName: "GitHub Pages",
    },
    {
      imgAltText: "Netlify",
      imgSrc: L_NETLIFY,
      skillName: "Netlify",
    },
  ],
  programmingLanguages: [
    {
      imgAltText: "C Programming",
      imgSrc: L_C_PROG,
      skillName: "C Programming",
    },
    {
      imgAltText: "C++",
      imgSrc: L_CPP,
      skillName: "C++",
    },

    {
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },

    {
      imgAltText: "Python",
      imgSrc: L_PYTHON,
      skillName: "Python",
    },

    {
      imgAltText: "Java",
      imgSrc: L_JAVA,
      skillName: "Java",
    },
    {
      imgAltText: "Arduino",
      imgSrc: L_ARDUINO,
      skillName: "Arduino",
    },

    {
      imgAltText: "R Programming",
      imgSrc: L_R_PROG,
      skillName: "R Programming",
    },
  ],
  databases: [
    {
      imgAltText: "MY-SQL",
      imgSrc: L_MYSQL,
      skillName: "MY-SQL",
    },
    {
      imgAltText: "MongoDB",
      imgSrc: L_MONGODB,
      skillName: "MongoDB",
    },
  ],
  others: [
    {
      imgAltText: "GIT",
      imgSrc: L_GIT,
      skillName: "GIT",
    },
    {
      imgAltText: "SolidWorks",
      imgSrc: L_SOLIDWORKS,
      skillName: "SolidWorks",
    },
  ],
};
